export default "__VITE_ASSET__DtyOQI26__"